var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex flex-column" },
    [
      _vm._l(_vm.radios, function(radio, i) {
        return _c(
          "div",
          { staticClass: "d-flex flex-row align-items-center" },
          [
            _c(
              "div",
              { staticClass: "form-check d-flex flex-row align-items-center" },
              [
                _c("input", {
                  staticClass: "form-check-input mt-0",
                  attrs: { type: "radio", name: _vm._uid + "radiogroup" },
                  domProps: { checked: radio.checked },
                  on: {
                    change: function($event) {
                      return _vm.selectRadio(i, $event.target.checked)
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: radio.label,
                        expression: "radio.label"
                      }
                    ],
                    staticClass: "form-control form-control-sm",
                    attrs: { type: "text" },
                    domProps: { value: radio.label },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.$set(radio, "label", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group-append" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-danger ml-auto",
                        on: {
                          click: function($event) {
                            return _vm.radios.splice(i, 1)
                          }
                        }
                      },
                      [_c("i", { staticClass: "fa fa-trash" })]
                    )
                  ])
                ])
              ]
            )
          ]
        )
      }),
      _vm._v(" "),
      !_vm.radios.length
        ? _c("span", [_vm._v("(" + _vm._s(_vm.$t("general.noEntries")) + ")")])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "ml-auto" }, [
        _c("div", { staticClass: "btn-group" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-success",
              on: {
                click: function($event) {
                  return _vm.radios.push({ label: "", checked: false })
                }
              }
            },
            [_c("i", { staticClass: "fa fa-plus" })]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-primary",
              on: { click: _vm.notifyChange }
            },
            [_c("i", { staticClass: "fa fa-save" })]
          )
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }